"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSweetProgress = require("react-sweet-progress");

var _ProgressWrapper = _interopRequireDefault(require("./ProgressWrapper"));

var _icons = require("../icons");

var _theme = require("../../styles/theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var normalizePercent = function normalizePercent(percent) {
  var roundedPercent = Math.round(percent);
  var min = 0;
  var max = 100;
  return Math.min(Math.max(roundedPercent, min), max);
};

var ProgressBar = function ProgressBar(props) {
  var percent = props.percent,
      status = props.status;
  var normalizedPercent = normalizePercent(percent);

  var errorIcon = /*#__PURE__*/_react.default.createElement(_icons.Icon, {
    type: "x",
    color: _theme.colors.red.primary
  });

  var successIcon = /*#__PURE__*/_react.default.createElement(_icons.Icon, {
    type: "checkmark",
    color: _theme.colors.green.primary
  });

  var theme = {
    error: {
      symbol: errorIcon,
      color: _theme.colors.red.primary
    },
    default: {
      symbol: "".concat(normalizedPercent, "%"),
      color: _theme.colors.blue.secondaryDark
    },
    active: {
      symbol: "".concat(normalizedPercent, "%"),
      color: _theme.colors.blue.secondaryDark
    },
    success: {
      symbol: successIcon,
      color: _theme.colors.green.primary
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ProgressWrapper.default, null, /*#__PURE__*/_react.default.createElement(_reactSweetProgress.Progress, {
    theme: theme,
    percent: normalizedPercent,
    status: status
  }));
};

exports.ProgressBar = ProgressBar;
ProgressBar.propTypes = {
  status: _propTypes.default.oneOf(['error', 'default', 'active', 'success']),
  percent: _propTypes.default.number
};
ProgressBar.defaultProps = {
  status: 'default',
  percent: 0
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/progress_bar/ProgressBar.js
// module id = 764
// module chunks = 0 15 16 17 18